import { H2RInput } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Timezone offset (+/- hours)"
				value={cue.timezoneOffset}
				placeholder="0"
				type="number"
				step={1}
				min={-12}
				max={12}
				onChange={(value) => {
					onUpdate({ timezoneOffset: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{"Time of day"}</span>
		</div>
	);
};
